import { useEffect } from 'react';
import { showResetPasswordSuccessModal } from 'src/reset-password/business-logic/forgot-password';

export const useShowResetSuccessModal = (showResetSuccessModal, user) => {
  useEffect((): void => {
    if (user && user.userName) {
      showResetPasswordSuccessModal(showResetSuccessModal, user.userName);
    }
  }, [showResetSuccessModal, user]);
};
